import Instance from '../../../../utils/Axios';

const GetSyncFerias = (recursoId) => async (dispatch) => {
  const stateToken = localStorage.token;
  if (recursoId) {
    await Instance()
      .get(`/syncdiasferias/auto/${recursoId}`)
      .then(({ data }) => {
        if (stateToken && dispatch) {
          dispatch({
            type: 'GET_SYNC_FERIAS',
            payload: data,
          });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default GetSyncFerias;
